
import { defineComponent, computed, onMounted, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import KTAside from "@/layout/aside/Aside.vue";
import KTHeader from "@/layout/header/Header.vue";
import KTFooter from "@/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import { getCookie, setCookie, removeCookie } from "typescript-cookie";

import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTLoader from "@/components/Loader.vue";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import { removeModalBackdrop } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

// localStorage flag so the "integrations renewed" notice shows only once.
const RENEWED_NOTICE_KEY = "tekpanel_integrations_renewed_notice_v1";

import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from "@/core/helpers/config";

export default defineComponent({
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTToolbar,
    KTScrollTop,
    KTLoader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    const isViewOnly = computed(() => store.getters.isViewOnly);
    const goBilling = () => router.push({ name: "billing" });

    onMounted(async () => {
      //check if current user is authenticated
      if (getCookie("access_token") == null) {
        router.push({ name: "sign-in" });
        if (getCookie("refresh_token") != null) {
          removeCookie("refresh_token");
        }
      } else {
        // Load subscription status (drives the view-only banner) and show the
        // one-time "integrations renewed" notice.
        store.dispatch(Actions.GET_SUBSCRIPTION);
        if (!localStorage.getItem(RENEWED_NOTICE_KEY)) {
          localStorage.setItem(RENEWED_NOTICE_KEY, "1");
          Swal.fire({
            title: "Entegrasyonlar Yenilendi 🎉",
            html: "Tüm entegrasyonlarımızı (Yemeksepeti, Getir, Trendyol) yeni nesil altyapıya taşıdık.<br/><br/>Lütfen <b>bilgilerinizi güncelleyerek</b> çalışmayan entegrasyonlarınızı tekrar bağlayın.",
            icon: "info",
            confirmButtonText: "Anladım",
          });
        }
      }

      nextTick(() => {
        reinitializeComponents();
      });
      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        removeModalBackdrop();
        nextTick(() => {
          reinitializeComponents();
        });
      }
    );

    return {
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      themeLightLogo,
      themeDarkLogo,
      isViewOnly,
      goBilling,
    };
  },
});
